/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { JobStageListItemDto, JobStagesFilterDto } from '@gh/builder-shared-data';
import { createArrayHelper } from '@gh/common-shared';
import { IdWithOptimisticLock } from '@gh/common-shared-data';

export type JobStageListItem = JobStageListItemDto;

export type JobStagesFilter = JobStagesFilterDto;

export const getJobStagesListItemId = (jobStage: JobStageListItem) => jobStage.id;

export const jobStagesArr = createArrayHelper(getJobStagesListItemId);

export function jobStageListToOrder(jobStages: JobStageListItem[]): IdWithOptimisticLock[] {
  return jobStages.map(({ id, etag }) => ({ id, etag }));
}
